function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** Custom implementation of DayPickerSingleDateController from react-dates. */
import React from 'react';
import PropTypes from 'prop-types';
import momentPropTypes from 'react-moment-proptypes';
import moment from 'moment';
import omit from 'lodash/omit';
import cx from 'classnames';
import DayPickerSingleDateController from 'react-dates/lib/components/DayPickerSingleDateController';
import { HORIZONTAL_ORIENTATION } from 'react-dates/lib/constants';
import isInclusivelyAfterDay from 'react-dates/lib/utils/isInclusivelyAfterDay';
import KeyListener from '../utils/KeyListener';
import SingleDateInput from './SingleDateInput';
import Icon from '../Icon';
var propTypes = {
  date: PropTypes.oneOfType([PropTypes.object, momentPropTypes.momentObj, PropTypes.string]),
  dateOffset: PropTypes.func,
  minDate: momentPropTypes.momentObj,
  maxDate: momentPropTypes.momentObj,
  keepOpenOnDateSelect: PropTypes.bool,
  minimumNights: PropTypes.number,
  isOutsideRange: PropTypes.func,
  isDayBlocked: PropTypes.func,
  isDayHighlighted: PropTypes.func,
  daysViolatingMinNightsCanBeClicked: PropTypes.bool,
  // DayPicker props
  enableOutsideDays: PropTypes.bool,
  numberOfMonths: PropTypes.number,
  // orientation: ScrollableOrientationShape,
  verticalHeight: PropTypes.number,
  withPortal: PropTypes.bool,
  initialVisibleMonth: PropTypes.func,
  renderCalendarInfo: PropTypes.func,
  renderMonthElement: PropTypes.func,
  renderMonthText: PropTypes.func,
  navPrev: PropTypes.node,
  navNext: PropTypes.node,
  renderNavPrevButton: PropTypes.func,
  renderNavNextButton: PropTypes.func,
  onPrevMonthClick: PropTypes.func,
  onNextMonthClick: PropTypes.func,
  onOutsideClick: PropTypes.func,
  renderCalendarDay: PropTypes.func,
  renderDayContents: PropTypes.func,
  renderKeyboardShortcutsButton: PropTypes.func,
  renderKeyboardShortcutsPanel: PropTypes.func,
  // i18n
  monthFormat: PropTypes.string,
  isRTL: PropTypes.bool,
  // DDS additions
  label: PropTypes.string,
  className: PropTypes.string,
  onDateChange: PropTypes.func,
  onFocusChange: PropTypes.func,
  focused: PropTypes.bool,
  phrases: PropTypes.object,
  displayFormat: PropTypes.string,

  /** List of allowed date formats */
  customFormatList: PropTypes.array
};
var defaultProps = {
  initialDate: null,
  date: null,
  dateOffset: undefined,
  minDate: null,
  maxDate: null,
  // day presentation and interaction related props
  renderCalendarDay: undefined,
  renderDayContents: null,
  // minimumNights: 1,
  isDayBlocked: function isDayBlocked() {
    return false;
  },
  isOutsideRange: function isOutsideRange(day) {
    return !isInclusivelyAfterDay(day, moment());
  },
  isDayHighlighted: function isDayHighlighted() {
    return false;
  },
  enableOutsideDays: false,
  // calendar presentation and interaction related props
  orientation: HORIZONTAL_ORIENTATION,
  verticalHeight: undefined,
  withPortal: false,
  initialVisibleMonth: null,
  numberOfMonths: 2,
  onOutsideClick: function onOutsideClick() {},
  keepOpenOnDateSelect: false,
  renderCalendarInfo: null,
  isRTL: false,
  renderMonthText: null,
  renderMonthElement: null,
  renderKeyboardShortcutsButton: undefined,
  renderKeyboardShortcutsPanel: undefined,
  customFormatList: [],
  // navigation related props
  navPrev: null,
  navNext: null,
  renderNavPrevButton: null,
  renderNavNextButton: null,
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  // internationalization
  monthFormat: 'MMMM YYYY'
};

var SingleDatePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(SingleDatePicker, _React$Component);

  var _super = _createSuper(SingleDatePicker);

  function SingleDatePicker(props) {
    var _this;

    _classCallCheck(this, SingleDatePicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (date) {
      var _this$props = _this.props,
          onDateChange = _this$props.onDateChange,
          displayFormat = _this$props.displayFormat;
      var correctDate = null;

      if (date) {
        correctDate = typeof date.date === 'string' ? moment(date.date, displayFormat) : date;
      }

      onDateChange(correctDate);

      if (correctDate) {
        _this.setState({
          isFocusOnCalendar: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onInputFocus", function (target) {
      var onFocusChange = _this.props.onFocusChange;
      onFocusChange(target);
    });

    _defineProperty(_assertThisInitialized(_this), "onDayPickerBlur", function () {
      var onFocusChange = _this.props.onFocusChange;

      _this.setState({
        isFocusOnCalendar: false
      });

      onFocusChange(null);
    });

    _defineProperty(_assertThisInitialized(_this), "onDownArrow", function (e) {
      e.preventDefault();
      var focused = _this.props.focused;

      if (focused) {
        _this.setState({
          isFocusOnCalendar: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onTab", function () {
      var _this$props2 = _this.props,
          date = _this$props2.date,
          displayFormat = _this$props2.displayFormat;
      var isFocusOnCalendar = _this.state.isFocusOnCalendar;
      var isDateValid = moment(date, displayFormat);

      if (isFocusOnCalendar) {
        _this.closeDatePicker();
      }

      if (isDateValid) {
        _this.closeDatePicker();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "closeDatePicker", function () {
      var onFocusChange = _this.props.onFocusChange;
      onFocusChange(null);

      _this.setState({
        isFocusOnCalendar: false
      });
    });

    _this.state = {
      isFocusOnCalendar: false
    };
    return _this;
  }

  _createClass(SingleDatePicker, [{
    key: "render",
    value: function render() {
      var isFocusOnCalendar = this.state.isFocusOnCalendar;
      var _this$props3 = this.props,
          className = _this$props3.className,
          phrases = _this$props3.phrases,
          onFocusChange = _this$props3.onFocusChange,
          date = _this$props3.date,
          focused = _this$props3.focused,
          onDateChange = _this$props3.onDateChange,
          displayFormat = _this$props3.displayFormat;
      var props = omit(this.props, ['autoFocus', 'id', 'placeholder', 'startDate', 'endDate', 'focusedInput', 'onDatesChange', 'startDateId', 'endDateId', 'customProps', 'dateOffset', 'minDate', 'maxDate', 'initialDate', 'displayFormat', 'onOutsideClick', 'label', 'renderKeyboardShortcutsButton', 'renderKeyboardShortcutsPanel', 'renderNavPrevButton', 'renderNavNextButton', 'size', 'dateId', 'datePlaceholderText', 'nextVersion', 'description', 'type', 'onFilter', 'onCancel', 'onAccept', 'required', 'filters', 'disableTyping', 'error', 'applyButtonText', 'customFormatList']);
      var calendarClass = cx({
        datepicker: true,
        'position-absolute': true,
        'zindex-1': true
      }, className);
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(KeyListener, {
        onDown: this.onDownArrow,
        onTab: this.onTab
      }, /*#__PURE__*/React.createElement(SingleDateInput, _extends({}, this.props, {
        date: moment.isMoment(date) ? date.format(displayFormat) : '',
        onDateChange: this.onDateChange,
        onInputFocus: this.onInputFocus,
        onIconClick: this.onInputFocus,
        ref: this.dateInputRef
      }))), focused ? /*#__PURE__*/React.createElement("div", {
        className: calendarClass
      }, /*#__PURE__*/React.createElement(DayPickerSingleDateController, _extends({}, props, {
        onDateChange: onDateChange,
        onFocusChange: onFocusChange,
        date: date,
        isFocused: isFocusOnCalendar,
        onBlur: this.onDayPickerBlur,
        daySize: 34,
        phrases: phrases,
        onOutsideClick: this.closeDatePicker,
        navPrev: /*#__PURE__*/React.createElement(Icon, {
          name: "arrow_left"
        }),
        navNext: /*#__PURE__*/React.createElement(Icon, {
          name: "arrow_right"
        }),
        onClose: this.closeDatePicker
      }))) : null);
    }
  }]);

  return SingleDatePicker;
}(React.Component);

SingleDatePicker.propTypes = propTypes;
SingleDatePicker.defaultProps = defaultProps;
SingleDatePicker.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onDateChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "date",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onInputFocus",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "target",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onDayPickerBlur",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onDownArrow",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onTab",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "closeDatePicker",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "SingleDatePicker",
  "props": {
    "initialDate": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "required": false
    },
    "date": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "object"
        }, {
          "name": "custom",
          "raw": "momentPropTypes.momentObj"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": ""
    },
    "dateOffset": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "minDate": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "custom",
        "raw": "momentPropTypes.momentObj"
      },
      "required": false,
      "description": ""
    },
    "maxDate": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "custom",
        "raw": "momentPropTypes.momentObj"
      },
      "required": false,
      "description": ""
    },
    "renderCalendarDay": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "renderDayContents": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "isDayBlocked": {
      "defaultValue": {
        "value": "() => false",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "isOutsideRange": {
      "defaultValue": {
        "value": "day => !isInclusivelyAfterDay(day, moment())",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "isDayHighlighted": {
      "defaultValue": {
        "value": "() => false",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "enableOutsideDays": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "orientation": {
      "defaultValue": {
        "value": "HORIZONTAL_ORIENTATION",
        "computed": true
      },
      "required": false
    },
    "verticalHeight": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "withPortal": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "initialVisibleMonth": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "numberOfMonths": {
      "defaultValue": {
        "value": "2",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "onOutsideClick": {
      "defaultValue": {
        "value": "function() {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "keepOpenOnDateSelect": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "renderCalendarInfo": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "isRTL": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "renderMonthText": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "renderMonthElement": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "renderKeyboardShortcutsButton": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "renderKeyboardShortcutsPanel": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "customFormatList": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "List of allowed date formats"
    },
    "navPrev": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "navNext": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "renderNavPrevButton": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "renderNavNextButton": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onPrevMonthClick": {
      "defaultValue": {
        "value": "function() {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onNextMonthClick": {
      "defaultValue": {
        "value": "function() {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "monthFormat": {
      "defaultValue": {
        "value": "'MMMM YYYY'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "minimumNights": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "daysViolatingMinNightsCanBeClicked": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onDateChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onFocusChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "focused": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "phrases": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "displayFormat": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
export default SingleDatePicker;